// Helpers de fechas compartidos entre cliente (app.js) y servidor (index.ts).
// El MITMS publica un precio semanal cada lunes que cubre la semana en curso.

export function isoDay(d: Date | string): string {
  if (typeof d === 'string') return d.slice(0, 10);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Lunes de publicación que el MITMS asigna a una fecha:
//   - si la fecha es lunes → ese mismo lunes;
//   - martes a domingo → lunes inmediatamente siguiente.
// Regla verificada empíricamente contra la herramienta del ministerio.
export function lunesPublicacion(d: Date | string): string {
  if (typeof d === 'string') d = new Date(d);
  const day = d.getDay(); // 0=Dom, 1=Lun, ..., 6=Sáb
  const offset = day === 1 ? 0 : day === 0 ? 1 : 8 - day;
  const m = new Date(d.getTime());
  m.setDate(d.getDate() + offset);
  return isoDay(m);
}
